/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary, react/jsx-props-no-spreading, react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useLocation } from 'wouter';

import { getParentElement } from '../../lib/isInElement';

import styles from '../../styles/documents/newsletter-document.module.css';

const propTypes = {
    id: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    html: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    id: null,
    html: null,
    className: null,
};

function NewsletterDocument({ id, html, className }) {
    const [, setLocation] = useLocation();
    const [, body = null] = (html || '').match(/<body[^>]*>([\s\S.]*)<\/body>/) || [];
    const [, style = null] = (html || '').match(/<style[^>]*>([\s\S.]*)<\/style>/) || [];
    const onClick = useCallback((event) => {
        const link = getParentElement(event.target, 'a');
        const url = link !== null ? link.getAttribute('href') : null;
        console.log(event.target, link, url);
        if (url !== null && url.match(/urbania\.(ca|fr)/gi) !== null) {
            event.preventDefault();
            setLocation(url.replace(/^http?s:\/\/([^/]+)/, ''));
        }
    }, []);

    const finalBody = useMemo(() => {
        const div = document.createElement('div');
        div.innerHTML = (body || '').replace(/<body/, '<div').replace(/<\/body>/, '</div>');
        const rows = [...div.getElementsByClassName('row')];
        rows.forEach((row) => {
            const text = row.innerText.toLowerCase();
            const links = [...row.getElementsByTagName('a')];
            const shouldRemove =
                links.findIndex((a) => {
                    const url = a.getAttribute('href') || null;
                    return (
                        url !== null &&
                        (url.indexOf('desabonner') !== -1 ||
                            url.indexOf('unsubscribe') !== -1 ||
                            url.indexOf('compte/abonnements') !== -1)
                    );
                }) !== -1 ||
                text.indexOf('lisez ce courriel dans un navigateur') !== -1 ||
                text.indexOf('suivez-nous quand même') !== -1 ||
                text.indexOf('suivez-nous sur les') !== -1;
            if (shouldRemove) {
                row.parentNode.removeChild(row);
                return;
            }
        });
        return div.innerHTML;
    }, [body]);

    return (
        <div className={classNames([styles.container, className])} id={`newsletter-${id}`}>
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: `#newsletter-${id} { ${style || ''} }`,
                }}
            />
            <div
                dangerouslySetInnerHTML={{
                    __html: finalBody,
                }}
                onClick={onClick}
            />
        </div>
    );
}

NewsletterDocument.propTypes = propTypes;
NewsletterDocument.defaultProps = defaultProps;

export default NewsletterDocument;
